import { IntersectionObserver } from '../../node_modules/intersection-observer'

window.addEventListener('DOMContentLoaded', () => {
	const groupType1Elements = document.querySelectorAll('.voetlicht-group--group-style-1 > div:nth-child(2), .voetlicht-group--group-style-4 > div:nth-child(2)')
	const clipGroup1and4Elements = () => {
		if (document.body.getBoundingClientRect().width > 1024) {
			groupType1Elements.forEach(element => {
				const height = parseFloat(element.offsetHeight);
				const radius = height * 1.5;
				element.style.clipPath = `circle(${radius}px at ${radius}px ${height / 2}px)`;
			});
		} else {
			groupType1Elements.forEach(element => {
				element.style.clipPath = ''
			})
		}
	}
	clipGroup1and4Elements()

	const clipGroup2Elements = () => {
		const groupType2Elements = document.querySelectorAll('.voetlicht-group--group-style-2 > div:nth-child(1)')
		if (document.body.getBoundingClientRect().width > 1024) {			
			groupType2Elements.forEach(element => {
				const box = element.getBoundingClientRect()
				const height = parseFloat(box.height);
				const radius = height * 1.5;
				element.style.clipPath = `circle(${radius}px at ${box.width - radius}px ${height / 2}px)`;
			});
		} else {
			groupType2Elements.forEach(element => {
				element.style.clipPath = ''
			})
		}
	}
	clipGroup2Elements()

	const clipFooter = () => {
		const footer = document.querySelector("footer")
		const width = parseFloat(footer.getBoundingClientRect().width);
		const radius = width * 2.5;
		footer.style.clipPath = `circle(${radius}px at ${width /2}px ${radius}px)`;
	}
	clipFooter();

	window.addEventListener('resize', () => {clipFooter(), clipGroup2Elements(), clipGroup1and4Elements()})

	const newHeader = document.querySelector('header').cloneNode(true)
	newHeader.classList.add('stickyversion')
	document.body.appendChild(newHeader)
	let scrollTop = window.scrollY
	const revealStickyHeader = () => {
		if (scrollTop > 10) {
			document.querySelector('header.stickyversion').classList.add('visible')
		} else {
			document.querySelector('header.stickyversion').classList.remove('visible')
		}
	}
	window.addEventListener('scroll', () => {
		scrollTop = window.scrollY
		requestAnimationFrame(revealStickyHeader)
	})

	let observer = new window.IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('in-sight')
				return
			}
			entry.target.classList.remove('in-sight')
		})
	},
	{
		threshold: 1.0
	})
	document.querySelectorAll('.voetlicht--hasspotlight').forEach(spotlight => {
		observer.observe(spotlight)
	})

	window.addEventListener('focusin', e => {
		if (e.target.classList.contains('wpcf7-form-control')) {
			e.target.parentElement.parentElement.parentElement.classList.add('focus')
		}
	})
	window.addEventListener('focusout', e => {
		if (e.target.classList.contains('wpcf7-form-control')) {
			e.target.parentElement.parentElement.parentElement.classList.remove('focus')
		}
	})

	window.addEventListener('click', e => {
		if (e.target.hasAttribute('data-wp-on--click')
			&& e.target.getAttribute('data-wp-on--click') === 'actions.core.navigation.openMenuOnClick') {
				document.querySelectorAll('.wp-block-navigation__responsive-container').forEach(menu => {
					menu.classList.add('has-modal','is-menu-open')
				})
		}
		if (e.target.hasAttribute('data-wp-on--click')
			&& e.target.getAttribute('data-wp-on--click') === 'actions.core.navigation.closeMenuOnClick') {
				document.querySelectorAll('.wp-block-navigation__responsive-container').forEach(menu => {
					menu.classList.remove('has-modal','is-menu-open')
				})
		}
	})
})